import { IClinic } from 'model/v2';
import { useState } from 'react';
import { useQuery } from 'react-apollo';
import { GET_CLINICS, GET_CLINICS_NO_CERTS } from '../queries/Clinics';
import { ICalendarResource } from 'model/calendar/filters';
import { calendarGroup } from 'model/calendar/groups';

export const useClinicDataMap = (status: String) => {
  const [providersMap, setProvidersMap] = useState(
    new Map<number, ICalendarResource>()
  );
  const [clinicsMap, setClinicsMap] = useState(new Map());
  const { loading: loadingClinics, error: errorClinics } = useQuery(
    GET_CLINICS,
    {
      variables: { status: status },
      onCompleted: data => {
        const newClinicsMap = new Map();
        const newProvidersMap: Map<number, ICalendarResource> = new Map();
        data?.clinicsWithProvidersWithRooms?.forEach((clinic: IClinic) => {
          newClinicsMap.set(clinic.id, {
            id: clinic.id,
            name: clinic.name,
            abbreviation: clinic.abbreviation,
            clinicHub: clinic.clinicHub,
            clinicType: clinic.clinicType,
            clinicState: clinic.address?.state,
            timezone: clinic.timezone,
            providers: clinic.providers?.map(provider => {
              const mapped = {
                id: provider.id!,
                name: provider.name,
                telehealth: provider.telehealth,
                firstName: provider.firstName,
                lastName: provider.lastName,
                displayName: provider.displayName!,
                appointmentTypes: provider.appointmentTypes,
                clinic: {
                  id: clinic.id,
                  name: clinic.name,
                  abbreviation: clinic.abbreviation,
                  timezone: clinic.timezone,
                  address: clinic.address
                },
                speciality: provider.speciality,
                status: provider.status,
                telehealthLinks: provider.telehealthLinks,
                corticaPrograms: provider.corticaPrograms,
                attendeeType: calendarGroup.provider,
                certificationMappings: provider.certificationMappings
              };
              newProvidersMap.set(provider.id!, mapped);
              return mapped;
            }),
            rooms: clinic.rooms?.map(x => {
              return {
                ...x,
                clinic: {
                  id: clinic.id
                }
              };
            })
          });
        });
        setProvidersMap(newProvidersMap);
        setClinicsMap(newClinicsMap);
      },
      fetchPolicy: 'no-cache'
    }
  );

  return { providersMap, clinicsMap, loadingClinics, errorClinics };
};

export const useClinicDataNoCertsMap = (status: string) => {
  const [providersMap, setProvidersMap] = useState(
    new Map<number, ICalendarResource>()
  );
  const [clinicsMap, setClinicsMap] = useState(new Map());
  const { loading: loadingClinics, error: errorClinics } = useQuery(
    GET_CLINICS_NO_CERTS,
    {
      variables: { status: status },
      onCompleted: data => {
        const newClinicsMap = new Map();
        const newProvidersMap: Map<number, ICalendarResource> = new Map();
        data?.clinicsWithProvidersNoCerts?.forEach((clinic: IClinic) => {
          newClinicsMap.set(clinic.id, {
            id: clinic.id,
            name: clinic.name,
            abbreviation: clinic.abbreviation,
            clinicHub: clinic.clinicHub,
            clinicType: clinic.clinicType,
            clinicState: clinic.address?.state,
            timezone: clinic.timezone,
            providers: clinic.providers?.map(provider => {
              const mapped = {
                id: provider.id!,
                name: provider.name,
                telehealth: provider.telehealth,
                firstName: provider.firstName,
                lastName: provider.lastName,
                displayName: provider.displayName!,
                appointmentTypes: provider.appointmentTypes,
                clinic: {
                  id: clinic.id,
                  name: clinic.name,
                  abbreviation: clinic.abbreviation,
                  timezone: clinic.timezone,
                  address: clinic.address
                },
                speciality: provider.speciality,
                status: provider.status,
                telehealthLinks: provider.telehealthLinks,
                corticaPrograms: provider.corticaPrograms,
                attendeeType: calendarGroup.provider
              };
              newProvidersMap.set(provider.id!, mapped);
              return mapped;
            })
          });
        });
        setProvidersMap(newProvidersMap);
        setClinicsMap(newClinicsMap);
      },
      fetchPolicy: 'no-cache'
    }
  );

  return { providersMap, clinicsMap, loadingClinics, errorClinics };
};
